import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './ComingSoon.css';

// Import logo
import luminaLogo from '../assets/luminalogo3.png';

const ComingSoon = () => {
    const navigate = useNavigate();
    const [showElements, setShowElements] = useState(false);

    // Show button and footer after 2 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowElements(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="coming-soon-page">
            {/* Background particles */}
            <div className="coming-soon-particles">
                <div className="particles-glow" />
                {[...Array(20)].map((_, index) => (
                    <div key={index} className="particle" />
                ))}
            </div>

            {/* Main content */}
            <motion.div
                className="coming-soon-content"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2, ease: 'easeOut' }}
            >
                {/* Logo */}
                <motion.div
                    className="coming-soon-logo"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1.5, delay: 0.3 }}
                >
                    <img src={luminaLogo} alt="Lumina Logo" />
                </motion.div>

                {/* Divider */}
                <motion.div
                    className="coming-soon-divider"
                    initial={{ width: 0 }}
                    animate={{ width: 120 }}
                    transition={{ duration: 1, delay: 0.9 }}
                />

                {/* Coming Soon Text */}
                <motion.h1
                    className="coming-soon-title"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5, delay: 0.6 }}
                >
                    Bald verfügbar
                </motion.h1>

                <motion.p
                    className="coming-soon-subtitle"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5, delay: 0.9 }}
                >
                    Wir arbeiten an etwas Besonderem. Schauen Sie bald wieder vorbei.
                </motion.p>

                {/* Back to Home Button */}
                <motion.button
                    className={`back-home-btn ${showElements ? 'show' : ''}`}
                    onClick={() => navigate('/')}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5, delay: 1.2 }}
                    whileHover={{ scale: 1.05, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Zurück zur Startseite
                </motion.button>
            </motion.div>

            {/* Footer */}
            {/*<motion.footer*/}
            {/*    className={`coming-soon-footer ${showElements ? 'show' : ''}`}*/}
            {/*    initial={{ opacity: 0 }}*/}
            {/*    animate={{ opacity: 1 }}*/}
            {/*    transition={{ duration: 1.5, delay: 1.5 }}*/}
            {/*>*/}
            {/*    <p>© 2025 Lumina. Alle Rechte vorbehalten.</p>*/}
            {/*</motion.footer>*/}
        </div>
    );
};

export default ComingSoon;
